import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';

@Pipe({
  name: 'formatPhoneNumber'
})
export class FormatPhoneNumberPipe implements PipeTransform {

  constructor(private auth: AuthService, private commonService: CommonService){

  }

  transform(value: string, passenger: any): string {
    let flag = false;
    if (passenger && value){
      if (passenger.emplGuid){
        flag = this.auth.getUser()?.employee?.guid !== passenger.emplGuid;
      }else{
        flag = this.auth.getUser()?.employee?.employeeId !== passenger.emplId;
      }
      if (this.commonService.workflowConfig?.hideOtherRiderMobileNumber && flag){
        value = value.replace(/[0-9]/g, 'x');
      }
    }
    return value;
  }

}
